import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import HeroDemoModal from "@/components/HeroDemoModal";
import LandingNav from "@/components/landing/LandingNav";
import LandingHero from "@/components/landing/LandingHero";
import { LandingProblem, LandingSolution } from "@/components/landing/LandingProblemSolution";
import { LandingHowItWorks, LandingCategories, LandingWhyHotels } from "@/components/landing/LandingSections";
import { LandingCompliance, LandingIntegrations } from "@/components/landing/LandingPlansCompliance";
import LandingFoundingProgram from "@/components/landing/LandingFoundingProgram";
import { LandingFinalCta, LandingFooter } from "@/components/landing/LandingFooter";

export default function Landing() {
  const [demoOpen, setDemoOpen] = useState(false);
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/trust/metrics");
        setMetrics(data);
      } catch (err) {
        console.warn("[Landing] /trust/metrics failed", err);
      }
    })();
  }, []);

  const openDemo = () => setDemoOpen(true);

  return (
    <div id="top" className="bg-white text-zinc-900 antialiased" data-testid="landing-page">
      <LandingNav onDemo={openDemo} />
      <LandingHero metrics={metrics} onDemo={openDemo} />
      <LandingProblem />
      <LandingSolution />
      <LandingHowItWorks />
      <LandingCategories />
      <LandingWhyHotels />
      <LandingCompliance />
      <LandingIntegrations />
      <LandingFoundingProgram />
      <LandingFinalCta onDemo={openDemo} />
      <LandingFooter />
      <HeroDemoModal open={demoOpen} onOpenChange={setDemoOpen} />
    </div>
  );
}
